import React from 'react';
import PropTypes from 'prop-types';

import styles from './troy.module.scss';
import picture from '../../../assets/img/recommend-help/01_rechner.png';

import Calculator from '.';

const TroyCalculator = ({
  firstName,
  lastName,
  email,
  mobilePhone,
  phone,
  currency,
  balance,
  onSubmit
}) => (
  <Calculator
    {...{
      styles,
      picture,
      firstName,
      lastName,
      currency,
      balance,
      onSubmit,
      email,
      mobilePhone,
      phone,
    }}
  />
);

TroyCalculator.propTypes = {
  firstName: PropTypes.string,
  lastName: PropTypes.string,
  currency: PropTypes.string,
  balance: PropTypes.number,
  onSubmit: PropTypes.func
};

export default TroyCalculator;
